// extracted by mini-css-extract-plugin
export default {"container":"Slider_container__qeOVL","title":"Slider_title__AbbGS","input":"Slider_input__PdB1+","value1":"Slider_value1__SUpFQ","value2":"Slider_value2__Ck1BT"};